import { modifyText } from '@arnold/core';
import parse from 'html-react-parser';
import { AnonymityLevel } from './constants';

export const formatText = (text: string): string | JSX.Element | JSX.Element[] => {
  return parse(text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>'));
};
export const getRawText = (text: string): string | JSX.Element | JSX.Element[] => {
  return parse(text.replace(/\[([^\]]+)\]\(([^)]+)\)/, '$1'));
};
export const replaceQuestionPlaceholders = (
  text: string,
  organizationName: string,
  firstDate: string,
  teamLeaderName: string,
) =>
  modifyText(text, {
    '%ORG_NAME%': organizationName,
    '%FIRST_DATE%': firstDate,
    '%TL_NAME%': teamLeaderName,
  });

// function to get the anonymity mode key for showing anonymity info
export const getAnonymityModeKeyForShowingAnonymityInfo = (
  defaultAnonymity: AnonymityLevel | null,
  allowedAnonymities: Array<AnonymityLevel | null>,
): 'anonymousWithNonAnonymousOption' | 'nonAnonymousWithAnonymousOption' | 'anonymous' | 'underName' => {
  const allowed = allowedAnonymities.filter(Boolean) as AnonymityLevel[];
  const def = defaultAnonymity;
  const hasNone = allowed.includes(AnonymityLevel.None);
  const hasOrg = allowed.includes(AnonymityLevel.Organization);
  if (hasNone && hasOrg) {
    return def === AnonymityLevel.Organization ? 'anonymousWithNonAnonymousOption' : 'nonAnonymousWithAnonymousOption';
  }
  if (!hasNone && !hasOrg) {
    return def === AnonymityLevel.Organization ? 'anonymous' : 'underName';
  }
  if (hasOrg && !hasNone) return 'anonymous';
  if (hasNone && !hasOrg) return 'underName';
  return 'nonAnonymousWithAnonymousOption';
};
